import { Avatar, Box, Button, Divider, Stack, Typography } from "@mui/material";

function NetworkSection() {
  const networkCards = [1, 2, 3, 4];
  const businessCards = [1, 2];
  return (
    <Stack
      sx={{
        width: "100%",
        minWidth: "63.5%",
        bgcolor: "#ffffff",
        borderRadius: "22px",
        p: "24px",
        height: "max-content",
      }}
    >
      <Typography variant="subtitle1" sx={{ color: "#000000" }}>
        Radius New York People you may know
      </Typography>
      <Divider
        sx={{
          height: "1px",
          bgcolor: "#EBEBEB",
          mx: "-25px",
          my: "16px",
          border: "none",
        }}
      />
      <Stack
        direction="row"
        id="network-cards-container"
        gap={2}
        sx={{ flexWrap: "wrap", py: "14px " }}
      >
        {networkCards.map((card) => (
          <Stack
            id="card"
            direction="column"
            sx={{
              width: "240px",
              borderRadius: "10px",
              boxShadow: "0px 0px 20.9px 0px rgba(0, 0, 0, 0.2)",
            }}
            justifyContent="center"
            alignItems="center"
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {" "}
              <Box
                component="img"
                src="/images/networkCardbackgroundImage.jpeg"
                sx={{
                  height: 100,
                  objectFit: "cover",
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                  width: "100%",
                  display: "block",
                }}
              ></Box>
              <Avatar
                sx={{
                  width: 72,
                  height: 72,
                  position: "absolute",
                  bottom: -35,
                  alignSelf: "center",
                }}
                src="/images/networkCardProfileImage.jpeg"
              ></Avatar>
            </Box>
            <Typography variant="h6" sx={{ pt: "50px", pb: "4px" }}>
              Julia Smith
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                textAlign: "center",
                lineHeight: "16px",
                pb: "16px",
                px: "10px",
              }}
            >
              Turning ideas into impactful, scalable software solutions
            </Typography>
            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                bgcolor: "#EAEAEA",
                px: "18px",
                py: "6px",
                borderRadius: "20px",
                fontSize: "14px",
              }}
            >
              New York
            </Typography>
            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                borderRadius: "20px",
                fontSize: "14px",
                my: "10px",
              }}
            >
              995k followers
            </Typography>
            <Button
              variant="contained"
              sx={{
                borderRadius: "20px",
                px: "72px",
                mb: "20px",
                minWidth: "auto",
                width: "auto",
                textTransform: "none",
                bgcolor: "#FDDF59",
                color: "#000000",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#fddf59",
                  boxShadow: "none",
                },
                "&:active": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
                "&:focus": {
                  outline: "none",
                  boxshadow: "none",
                },
                "& .MuiButtonBase-root": {
                  width: "auto !important",
                  minWidth: "0px !important",
                  padding: "0px",
                  boxshadow: "none",
                },
              }}
            >
              Connect
            </Button>
          </Stack>
        ))}
      </Stack>
      <Typography variant="subtitle1" sx={{ color: "#000000", pt: "12px" }}>
        People with industries that might interest you
      </Typography>
      <Divider
        sx={{
          height: "1px",
          bgcolor: "#EBEBEB",
          mx: "-25px",
          my: "16px",
          border: "none",
        }}
      />
      <Stack
        direction="row"
        id="network-cards-container"
        gap={2}
        sx={{ flexWrap: "wrap", py: "14px " }}
      >
        {businessCards.map((card) => (
          <Stack
            id="card"
            direction="column"
            sx={{
              width: "240px",
              borderRadius: "10px",
              boxShadow: "0px 0px 20.9px 0px rgba(0, 0, 0, 0.2)",
            }}
            justifyContent="center"
            alignItems="center"
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {" "}
              <Box
                component="img"
                src="/images/networkCardbackgroundImage.jpeg"
                sx={{
                  height: 100,
                  objectFit: "cover",
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                  width: "100%",
                  display: "block",
                }}
              ></Box>
              <Avatar
                sx={{
                  width: 72,
                  height: 72,
                  position: "absolute",
                  bottom: -35,
                  alignSelf: "center",
                }}
                src="/images/networkCardProfileImage.jpeg"
              ></Avatar>
            </Box>
            <Typography variant="h6" sx={{ pt: "50px", pb: "4px" }}>
              Julia Smith
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                textAlign: "center",
                lineHeight: "16px",
                pb: "16px",
                px: "10px",
              }}
            >
              Turning ideas into impactful, scalable software solutions
            </Typography>
            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                bgcolor: "#EAEAEA",
                px: "18px",
                py: "6px",
                borderRadius: "20px",
                fontSize: "14px",
              }}
            >
              New York
            </Typography>
            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                borderRadius: "20px",
                fontSize: "14px",
                my: "10px",
              }}
            >
              995k followers
            </Typography>
            <Button
              variant="contained"
              sx={{
                borderRadius: "20px",
                px: "72px",
                mb: "20px",
                minWidth: "auto",
                width: "auto",
                textTransform: "none",
                bgcolor: "#FDDF59",
                color: "#000000",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#fddf59",
                  boxShadow: "none",
                },
                "&:active": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
                "&:focus": {
                  outline: "none",
                  boxshadow: "none",
                },
                "& .MuiButtonBase-root": {
                  width: "auto !important",
                  minWidth: "0px !important",
                  padding: "0px",
                  boxshadow: "none",
                },
              }}
            >
              Connect
            </Button>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}

export default NetworkSection;
